import { Currency } from ".."

export interface WalletData {
    payout_account: any | PayoutAccount,
    payouts: any[] | Payout[],
    statistics: WalletStatistics | null,
    transactions: any[] | Transaction[],
    pan: {
        available: boolean,
        required: boolean
    }
}

export enum EarningCategory {
    CAMPAIGN = 'campaign',
    REFERRAL = 'referral'
}

export interface CategoryEarning {
    name: string,
    earnings: number,
}

export interface WalletStatistics {
    balance: number,
    earnings: number,
    currency: Currency,
    category_earnings: {
        [K in EarningCategory]: CategoryEarning
    }
}

export interface PayoutAccount {

}

export interface Payout {
    posted: string,
    status: 'processed' | 'queued' |'failed',
    amount: number,
    currency: Currency
}

export interface Transaction {
    posted: string,
    narration: string,
    dr_amount: number,
    cr_amount: number
    currency: Currency
}